import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { filter } from 'rxjs';

import { routeNames } from '../../../shared/route-names';
import { UserService } from '../../user/services/user.service';
import { SessionService, SessionState } from '../../auth/services/session.service';

export const LoggedInGuard = () => {
  const router = inject(Router);
  const userService = inject(UserService);
  const sessionService = inject(SessionService);

  const currentState = sessionService.getSessionState();
  
  if (currentState === SessionState.RESTORING || currentState === SessionState.UNKNOWN) {
    return sessionService.sessionState$.pipe(
      filter(state => state !== SessionState.RESTORING && state !== SessionState.UNKNOWN),
      map(state => _handleAuthResult(state === SessionState.AUTHENTICATED, router)),
      take(1)
    );
  }

  return _handleAuthResult(userService.isLoggedIn(), router);
};

function _handleAuthResult(isAuthenticated: boolean, router: Router): boolean {
  if (isAuthenticated) {
    return true;
  }
  
  router.navigateByUrl(routeNames.auth);
  return false;
}
